import React, {Component} from 'react';
import i18next from 'i18next';
import PropTypes from 'prop-types';

class CreateNewButton extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const buttonText = this.props.customText ? this.props.customText : i18next.t('links.new');
    let style = {
      marginBottom: 10,
    };
    if (this.props.customStyle) {
      style = {...style, ...this.props.customStyle};
    }

    return (<button
      className="btn btn-primary default-button"
      onClick={this.props.callBack}
      style={style}
    >
      {buttonText}
    </button>);
  }
}

CreateNewButton.propTypes = {
  callBack: PropTypes.func,
  customText: PropTypes.string,
  customStyle: PropTypes.object,
};

export default CreateNewButton;
